import 'tslib';
// load needed polyfills
import '@dojo/framework/shim/browser';
// supported moment locales
import 'moment/locale/es';
import 'moment/locale/fr';
import '@holmescorp/cut-scores';

import './has-setup';

import { includes } from 'lodash-es';
import ResizeObserver from 'resize-observer-polyfill';

// patch in ResizeObserver polyfill if necessary
import global from '@dojo/framework/shim/global';
// site-specific init
import { register_lp_widgets, setup_actions } from '@holmescorp/apic-init';
// site-specific theme
import fullTheme, { microTheme } from '@holmescorp/apic-theme';
// App config & startup
import { LccApp, ditarootsChange, onlineChange, registry } from '@holmescorp/lcc-app';
import { themeContext } from '@holmescorp/lcc-state';
import { siteInit } from '@holmescorp/site-init';

// PWA support
// import 'pwacompat';

// A2HS support
// import { AddToHomeWidget } from 'add-to-home';
// registry.define('AddToHomeScreen', AddToHomeWidget);

if (!global.ResizeObserver) {
	global.ResizeObserver = ResizeObserver;
}

const site = (window as any).hcstatic.portal_site;
const theme = includes(['msurv1', 'mqual1'], site) ? microTheme : fullTheme;

// Set the theme
themeContext.set(theme, site);

register_lp_widgets();
setup_actions();

// Start the site
siteInit(LccApp, registry, onlineChange);
